/* eslint-disable react/no-unused-state */
/* eslint-disable no-shadow */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Input, Label, Form, Alert } from 'reactstrap';
import { addEnterpriseGroupChange } from '../actions/Companies';
import { addNumberFieldChange, getCompanyNumbers } from '../actions/Numbers';
import CompanyAutocomplete from './CompanyAutocomplete';
import { VALIDATION_TEXT } from '../../src/lib/constants';


const AddEnterpriseGroupForm = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({ name: '', company: '' });
  const [errors, setErrors] = useState({});
  const token = localStorage.getItem('jwtToken');

  useImperativeHandle(ref, () => ({
    submitForm() {
      handleSubmit(new Event('submit'));
    },
  }));

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    const { addEnterpriseGroupChange } = props;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    addEnterpriseGroupChange({ name, value });
  };

  const onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const { addNumberFieldChange, user, addEnterpriseGroupChange, getCompanyNumbers, emails } = props;
    console.log('suggestion',suggestion);
    if (suggestion) {
      await getCompanyNumbers(token, suggestion._id, false, 'enterpriseAdmin', true);
      addNumberFieldChange(name, suggestion._id);
      addNumberFieldChange('assignedTo', { email: emails[0], _id: user._id });
      addEnterpriseGroupChange({ name: 'company', value: suggestion._id });
      setFormData((prevData) => ({ ...prevData, company: suggestion._id }));
    } else {
      addNumberFieldChange('company', value);
      addNumberFieldChange('userName', '');
      addEnterpriseGroupChange({ name: 'company', value: '' });
      setFormData((prevData) => ({ ...prevData, company: '' }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) {
      errors.name = VALIDATION_TEXT.ENTERPRISE_GROUP_NAME
    }
    if (!formData.company) {
      errors.company = VALIDATION_TEXT.ENTERPRISE_GROUP_COMPANY
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      props.onFormSubmit();
    } 
  };

  const { companies } = props;
  const { name } = formData;

  return (
    <Form onSubmit={handleSubmit} className="container">
      <FormGroup row>
        <Label for="name" sm={6}>
          Group Name:
        </Label>
        <Col sm={8}>
          <Input
            required
            placeholder="Group Name..."
            type="text"
            name="name"
            value={name}
            onChange={handleChange}
          />
          {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label for="company" sm={6}>
          Management Company:
        </Label>
        <Col sm={8}>
          <CompanyAutocomplete
            placeholder="Filter Company..."
            companies={companies.docs || []}
            onChange={onAddedCompanyChange}
          />
          {errors.company && <p style={{ color: 'red' }}>{errors.company}</p>}
        </Col>
      </FormGroup>
    </Form>
  );
});

const mapStateToProps = (state) => ({
  user: state.AppState.user,
  name: state.UIState.companies.addedCompany.name,
  companies: state.AppState.companies,
  emails: state.UIState.numbers.addNumberFieldChange,
});

const mapDispatchToProps = (dispatch) => ({
  addEnterpriseGroupChange: (companyData) => dispatch(addEnterpriseGroupChange(companyData)),
  addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
  getCompanyNumbers: (token, id, uid, type, gflag) =>
    dispatch(getCompanyNumbers(token, id, uid, type, gflag)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AddEnterpriseGroupForm);
